"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const decorators_1 = require("../../../common/decorators"); // Adjust the import according to your setup
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../../common/helpers/helpers");
const translations_1 = __importDefault(require("../../../common/translations"));
const CallToActionListItem_1 = __importDefault(require("../Interactive/CallToActionListItem"));
const Drawer_1 = __importDefault(require("../Interactive/Drawer"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const Map_1 = __importDefault(require("../../../webapp/components/Pages/Map"));
const CallToActionArea_1 = __importDefault(require("../../../common/components/CallToActions/CallToActionArea"));
const WebsiteModalContent_1 = __importDefault(require("../Interactive/WebsiteModalContent"));
const DocumentDetail_1 = __importDefault(require("../../../webapp/components/Detail/DocumentDetail"));
const VideoPlayer_1 = __importDefault(require("../../../common/components/Other/VideoPlayer"));
const useUrlParams_1 = require("../../hooks/useUrlParams");
const useAvailabilities_1 = __importDefault(require("../../hooks/useAvailabilities"));
const qrcode_react_1 = __importDefault(require("qrcode.react"));
const StyledDialog = (0, styled_components_1.default)(material_1.Dialog) `
  .MuiPaper-root {
    max-width: 700px;
    height: 800px;
    width: 100%;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .MuiDrawer-root {
    position: absolute;
  }

  .g-maps-container,
  .call-to-action-detail {
    height: 100%;
    width: 100%;
    background-color: white;
    color: black;
    flex-direction: column;

    .secondary-text {
      font-size: 2.5vmin;
    }

    .main-text {
      font-size: 5vmin;
    }

    canvas {
      width: 30vmin !important;
      height: 30vmin !important;
      border-radius: 5px;
      border: 2px solid white;
      box-shadow: 0 0 0 5px black;
    }
  }

  hr {
    margin: 15px 0;
  }
`;
const StyledDialogCloseButton = (0, styled_components_1.default)(material_1.IconButton) `
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: rgba(252, 248, 248, 1);

  &:hover {
    background-color: rgba(252, 248, 248, 0.8);
    transition: background-color 0.2s ease-in-out;
  }
`;
const DialogContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 490px;
  padding: 10px 32px;
`;
const TitlesContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
  min-width: 0;
`;
const HeaderRow = styled_components_1.default.div `
  display: flex;
  gap: 20px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;
const QrCodeContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;

  .qr-code {
    background-color: white;
  }
`;
const TextContainer = styled_components_1.default.div `
  overflow: auto;
`;
const DocumentTitle = styled_components_1.default.p `
  background-color: ${props => (props.isDocumentImage ? 'black' : 'rgb( 50, 54, 57 )')};
  margin: 0;
  color: white;
  padding: 20px 100px 20px 16px;
  width: 100%;
`;
const DocumentImageContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: black;

  img {
    width: 100%;
  }
`;
const ActionsContainer = styled_components_1.default.div `
  display: flex;
  gap: 8px;
  margin-top: 16px;

  & > * {
    display: flex;
    flex-direction: row;
    padding: 0;
    gap: 10px;
    height: auto;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 0 10px;
    color: black;

    .call-to-action-icon {
      width: auto;
      height: auto;
    }
    & > * {
      min-width: auto;

      svg {
        fill: ${props => props.theme.palette.mainAppColor.main};
      }
    }
  }
`;
const ImageContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 300px;
`;
const ItemImage = styled_components_1.default.div `
  height: 100%;
  width: 100%;
  object-fit: cover;
  background: linear-gradient(
    5deg,
    ${props => props.theme.palette.mainAppColor.main} 0%,
    ${props => props.theme.palette.mainAppColor.light} 11%,
    ${props => props.theme.palette.mainAppColor.dark} 100%
  );
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-image: ${props => props.src || 'none'};
`;
const ItemDetailModal = ({ isOpen = false, content, updateStore, timezone, currentLocale, }) => {
    var _a, _b;
    const [isDrawerOpen, setIsDrawerOpen] = (0, react_1.useState)('');
    const { brand, venue: urlVenue } = (0, useUrlParams_1.useUrlParams)();
    const availabilityFromHook = (0, useAvailabilities_1.default)(content, brand, urlVenue);
    const availabilityState = (_b = (_a = content === null || content === void 0 ? void 0 : content.availability) === null || _a === void 0 ? void 0 : _a.availabilityState) !== null && _b !== void 0 ? _b : availabilityFromHook;
    const closeDialog = () => {
        updateStore('isDialogOpen', false);
        updateStore('isCarouselPaused', false);
    };
    (0, react_1.useEffect)(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                closeDialog();
            }
        };
        updateStore('isCarouselPaused', true);
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    if (!content) {
        return null;
    }
    const isBookable = content.bookable &&
        (availabilityState === 'available' ||
            availabilityState === 'few_places_left' ||
            availabilityState === 'user_has_active_booking');
    const isDocument = content.type === 'document';
    const isDocumentPDF = isDocument && content.contentType === 'application/pdf';
    const isDocumentImage = isDocument && content.contentType.includes('image');
    const renderActivityTime = () => {
        const locale = translations_1.default.currentLocale();
        const { date: datePart, time: timePart } = helpers_1.Helpers.getDateFromStringDependingLocale(content.start, locale, timezone, true);
        const endTime = helpers_1.Helpers.getHourFromDate(content.end, timezone, locale);
        const isGermanLocale = locale === null || locale === void 0 ? void 0 : locale.toLowerCase().startsWith('de');
        const timePartWithSuffix = isGermanLocale ? `${timePart} Uhr` : timePart;
        const endTimeWithSuffix = isGermanLocale ? `${endTime} Uhr` : endTime;
        if (content.showStartTime && content.showEndTime) {
            return `${datePart} • ${timePart} - ${endTimeWithSuffix}`;
        }
        if (content.showStartTime && !content.showEndTime) {
            return `${datePart} • ${timePartWithSuffix}`;
        }
        return datePart;
    };
    const renderDrawerContent = () => {
        switch (isDrawerOpen) {
            case 'map':
                return react_1.default.createElement(Map_1.default, { selectedVenue: content });
            case 'phone':
                return (react_1.default.createElement(CallToActionArea_1.default, { mainText: content.phone, secondaryText: translations_1.default.t('dictionary.handover.call_message', { currentLocale }), qrValue: content.phone }));
            case 'email':
                return (react_1.default.createElement(CallToActionArea_1.default, { mainText: content.email, secondaryText: translations_1.default.t('dictionary.handover.email_message', {
                        currentLocale,
                    }), qrValue: content.email }));
            case 'book':
                return (react_1.default.createElement(CallToActionArea_1.default, { mainText: "Book with Ease", secondaryText: "Scan the QR code with your phone to complete your reservation in the app.", qrValue: content.deeplink }));
            default:
                return null;
        }
    };
    // Make content links open in a new tab
    const processHtmlLinks = (html) => {
        const div = document.createElement('div');
        div.innerHTML = html;
        const links = div.querySelectorAll('a');
        links.forEach(link => {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
        });
        return div.innerHTML;
    };
    const locale = content.locale ? content.locale : currentLocale;
    const renderByType = () => {
        switch (content.type) {
            case 'document':
                return react_1.default.createElement(DocumentDetail_1.default, { documentData: content });
            case 'website':
                return react_1.default.createElement(WebsiteModalContent_1.default, { websiteData: content });
            default:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(HeaderRow, null,
                        react_1.default.createElement(TitlesContainer, null,
                            react_1.default.createElement(material_1.Typography, { variant: "h5" }, content.title),
                            (content === null || content === void 0 ? void 0 : content.type) === 'activity' && (react_1.default.createElement(material_1.Typography, { variant: "body1", className: "activity-time", "data-testid": "activity-time" }, renderActivityTime())),
                            react_1.default.createElement(material_1.Typography, { variant: "body1" }, content === null || content === void 0 ? void 0 : content.placeName)),
                        content.deeplink && isBookable && (react_1.default.createElement(QrCodeContainer, null,
                            react_1.default.createElement(qrcode_react_1.default, { value: content.deeplink, size: 100, className: "qr-code" }),
                            react_1.default.createElement(material_1.Typography, { variant: "body2", align: "center" }, translations_1.default.t('dictionary.handover.booking_message', { currentLocale }))))),
                    (content.website || content.phone || content.email || content.placeName) && (react_1.default.createElement(ActionsContainer, null,
                        (content === null || content === void 0 ? void 0 : content.website) && (react_1.default.createElement(CallToActionListItem_1.default, { activeItem: { content }, icon: "website", destination: "website", text: translations_1.default.t('website', { locale }) })),
                        (content === null || content === void 0 ? void 0 : content.phone) && (react_1.default.createElement(CallToActionListItem_1.default, { activeItem: { content }, onClick: () => setIsDrawerOpen('phone'), icon: "call", destination: "call", text: translations_1.default.t('tab_call', { locale }) })),
                        (content === null || content === void 0 ? void 0 : content.email) && (react_1.default.createElement(CallToActionListItem_1.default, { activeItem: { content }, onClick: () => setIsDrawerOpen('email'), icon: "email", destination: "email", text: translations_1.default.t('tab_email', { locale }) })),
                        (content === null || content === void 0 ? void 0 : content.placeName) && (content === null || content === void 0 ? void 0 : content.lat) && (content === null || content === void 0 ? void 0 : content.lng) && (react_1.default.createElement(CallToActionListItem_1.default, { activeItem: { content }, onClick: () => setIsDrawerOpen('map'), icon: "room", destination: "map", text: translations_1.default.t('map', { locale }) })))),
                    react_1.default.createElement(material_1.Divider, null),
                    (content === null || content === void 0 ? void 0 : content.text) && react_1.default.createElement(TextContainer, { dangerouslySetInnerHTML: { __html: processHtmlLinks(content.text) } })));
        }
    };
    if (isDocumentPDF || isDocumentImage) {
        return (react_1.default.createElement(StyledDialog, { open: isOpen, onClose: closeDialog },
            react_1.default.createElement(StyledDialogCloseButton, { "aria-label": "close dialog", onClick: closeDialog },
                react_1.default.createElement(Close_1.default, null)),
            react_1.default.createElement(DocumentTitle, { isDocumentImage: isDocumentImage }, content.title),
            isDocumentPDF && (react_1.default.createElement("iframe", { title: content.title, src: helpers_1.Helpers.isMobile.iOS()
                    ? `https://drive.google.com/viewerng/viewer?embedded=true&url=${encodeURIComponent(content.dataUrl)}?pid=explorer&toolbar=false&statusbar=0`
                    : content.dataUrl, width: "100%", height: "100%" })),
            isDocumentImage && (react_1.default.createElement(DocumentImageContainer, null,
                react_1.default.createElement("img", { src: content.dataUrl, alt: "modal-img" })))));
    }
    const imgUrl = content && content.images && content.images[0] && content.images[0]['2:1'] && content.images[0]['2:1'].L
        ? `url( ${content.images[0]['2:1'].L} )`
        : null;
    const iconUrl = content && content.icon && content.icon['2:1'] && content.icon['2:1'].L ? `url( ${content.icon['2:1'].L} )` : null;
    return (react_1.default.createElement(StyledDialog, { open: isOpen, onClose: closeDialog },
        react_1.default.createElement(StyledDialogCloseButton, { "aria-label": "close dialog", onClick: closeDialog },
            react_1.default.createElement(Close_1.default, null)),
        react_1.default.createElement(ImageContainer, null, content.videos && content.videos.length > 0 ? (react_1.default.createElement(VideoPlayer_1.default, { video: content.videos[0] })) : (react_1.default.createElement(ItemImage, { src: imgUrl || iconUrl }))),
        react_1.default.createElement(DialogContent, null, renderByType()),
        react_1.default.createElement(Drawer_1.default, { open: !!isDrawerOpen, onClose: () => setIsDrawerOpen('') }, renderDrawerContent())));
};
const mapStoreToProps = store => ({
    isOpen: store.getValue('isDialogOpen'),
    content: store.getValue('dialogContent'),
    timezone: store.getValue('timezone'),
    currentLocale: store.getValue('currentLocale'),
});
exports.default = (0, decorators_1.withStore)(mapStoreToProps)(ItemDetailModal);
